import { z } from 'zod';

export const zHttpHeaderKey = z
  .string()
  .regex(
    // Regex based on RFC 7230 token definition
    /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/,
    {
      message:
        "Invalid HTTP header key. Only letters, digits, and the following symbols are allowed: ! # $ % & ' * + - . ^ _ ` | ~",
    },
  )
  .refine((val) => val.trim().length > 0, {
    message: 'Header name cannot be empty or just whitespace',
  });
